import 'moment/locale/fr';
import en from 'react-intl/locale-data/en';
import fr from 'react-intl/locale-data/fr';

import PropTypes from 'prop-types';
import events from 'lib/events';
import Loader from '../loader.jsx';
import moment from 'moment';
import React from 'react';
import {languages, allowTranslations} from 'helpers/languageHelper';
import {IntlProvider, addLocaleData} from 'react-intl';
import session from 'services/sessionService';

const DEFAULT_LANGUAGE = 'en-US';
let ROOT_PATH = 'Content/copy/languages/';
const FILES_EXT = '.json';

if (!!window.canopyURL) {
  ROOT_PATH = window.canopyURL + '/' + ROOT_PATH;
}

const CACHE_KEY = 'locale';
const EXPIRY_KEY = 'locale-exp';

function cacheLocale(locale) {
  if (locale && locale === loadCachedLocale()) {
    // Don't update expiry time if setting to current language
    return;
  }

  localStorage.setItem(CACHE_KEY, locale);
  localStorage.setItem(EXPIRY_KEY, moment.utc().add(1, 'day').format());
}

function loadCachedLocale() {
  let locale = localStorage.getItem(CACHE_KEY);
  let exp = localStorage.getItem(EXPIRY_KEY);

  return locale && exp && moment.utc(exp).isAfter(moment.utc()) ? locale : undefined;
}


class IntlWrapper extends React.Component {
  static propTypes = {
    children: PropTypes.any,
  };

  constructor(props) {
    super(props);

    addLocaleData([...en, ...fr]);

    this.state = {
      allCopy: {},
      loaded: false,
      locale: DEFAULT_LANGUAGE,
      messages: {},
    };
  }

  componentWillMount() {
    if (!allowTranslations) {
      this.setCopy(DEFAULT_LANGUAGE, false);
      return;
    }

    if (session.getUser()) {
      this.setInitLanguage(session.getUser());
      return;
    }

    this.getUser()
      .then(user => this.setInitLanguage(user))
      .catch(() => this.setCopy(this.state.locale, false));
  }

  componentDidMount() {
    events.subscribe('set.language', this.setCopy);
    events.subscribe('get.language', this.getAndPublishLanguage);
  }

  setInitLanguage = user => {
    let language = loadCachedLocale() || user && user.locale || window.navigator.userLanguage || window.navigator.language;

    if (language) {
      return this.setCopy(language, false);
    }

    this.setCopy(DEFAULT_LANGUAGE, false);
  };

  setCopy = (locale, cache = true) => {
    if (this.state.allCopy[locale]) {
      moment.locale(languages[locale].time);

      if (cache) {
        cacheLocale(locale);
      }

      this.setState({loaded: true, messages: this.state.allCopy[locale], locale: locale},
        () => events.publish('locale.changed', {locale}));
      return;
    }

    this.fetchFile(locale)
      .then(() => {
        moment.locale(languages[locale].time);

        if (cache) {
          cacheLocale(locale);
        }
      })
      .catch(() => {
        console.log('Set locale', locale);

        if (cache) {
          cacheLocale(DEFAULT_LANGUAGE);
        }

        this.fetchFile(DEFAULT_LANGUAGE);
      });
  };

  fetchFile = locale => {
    return new Promise(
      (resolve, reject) => {
        fetch(ROOT_PATH.concat(locale, FILES_EXT) + `?v=${window.dateStamp || 1}`)
          .then(res => res.json())
          .then(data => {

            let tempArray = this.state.allCopy;

            tempArray[locale] = data;

            this.setState({
              allCopy: tempArray,
              loaded: true,
              locale: locale,
              messages: this.state.allCopy[locale],
            }, () => events.publish('locale.changed', {locale}));

            resolve();

          })
          .catch(e => {
            console.log('Error getting the language: ' + locale + '. Reason: ', e);
            reject(e);
          });
      }
    );
  };

  getUser = () => {
    // This cont will avoid over looping on logout
    let cont = 0;

    return new Promise((resolve, reject) => {
      (function waitUser() {
        if (session.getUser()) {
          return resolve(session.getUser());
        }
        cont++;
        if (cont === 10) {
          resolve();
        }
        setTimeout(waitUser, 30);
      })();
    });
  };

  getAndPublishLanguage = info => {
    if (!info.locale) {
      info.locale = DEFAULT_LANGUAGE;
    }

    if (this.state.allCopy[info.locale]) {
      events.publish(info.event, {locale: info.locale, messages: this.state.allCopy[info.locale]});
      return;
    }

    fetch(ROOT_PATH.concat(info.locale, FILES_EXT) + `?v=${window.dateStamp || 1}`)
      .then(res => res.json())
      .then(data => {
        events.publish(info.event, {locale: info.locale, messages: data});
      })
      .catch(e => {
        fetch(ROOT_PATH.concat(DEFAULT_LANGUAGE, FILES_EXT) + `?v=${window.dateStamp || 1}`)
          .then(res => res.json())
          .then(data => {
            events.publish(info.event, {locale: DEFAULT_LANGUAGE, messages: data});
          });
      });
  };

  render() {
    const {locale, messages, loaded} = this.state;

    return <IntlProvider locale={locale}
                         messages={messages} {...this.props}>
      {loaded ?
        <Loader loaded={loaded}>
          {this.props.children}
        </Loader> :
        <div/>}
    </IntlProvider>;
  }
}

export default IntlWrapper;
